import type { JSX } from 'react'

export const PlaySolidIcon = (): JSX.Element => (
  <use href='#playSolidIcon' height='100%' width='100%' />
)
